import {Route, Switch, useRouteMatch} from "react-router-dom";
import Profiles from "./profiles";
import BulkRisks from "./bulk/bulkRisks";

const  RiskDashboard = () => {
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let { path } = useRouteMatch();

  return (
  <div>
    <Switch>
      <Route exact path={path}>
        <Profiles/>
      </Route>
      <Route path={`${path}/bulk`}>
        <BulkRisks />
      </Route>
      
    </Switch>
  </div>
  );
}

export default RiskDashboard;